import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import Home from '@/components/views/Home';
import Loading from '@/components/views/Loading';
import PostGame from '@/components/views/PostGame';
import tutorial from '@/router/tutorial.routes';
import game from '@/router/game.routes';
import ending from '@/router/ending.routes';
import debug from '@/router/debug.routes';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "abstract",
	routes: [
		{
			path: '/',
			component: Home,
			beforeEnter(to, from, next) {
				if (!store.state.global.assets.loaded) {
					next({ path: "/loading" });
				} else {
					next();
				}
			},
		},
		{
			path: '/loading',
			component: Loading,
		},
		{
			path: '/postgame',
			component: PostGame,
			props: () => {
				const { outcome } = store.state.game;
				return store.state.global.api.data.ui.end_screen[outcome];
			},
		},
		...tutorial,
		...game,
		...ending,
		...debug,
	],
});

router.beforeEach((to, from, next) => {
	const debugPath = `/debug${to.fullPath}`;

	if (store.state.global.debug.active && debug.find((route) => route.path === debugPath)) {
		next({ path: debugPath });
	} else {
		next();
	}
});

// Prevent errors from redirects in beforeEnter Hooks
// TODO: See if this ever gets fixed/handeld better? https://github.com/vuejs/vue-router/issues/2932
VueRouter.prototype.unwrappedReplace = VueRouter.prototype.replace;
VueRouter.prototype.unwrappedPush = VueRouter.prototype.push;

VueRouter.prototype.replace = function push(location, onComplete, onAbort = () => {}) {
	this.unwrappedReplace(location, onComplete, onAbort);
};
VueRouter.prototype.push = function push(location, onComplete, onAbort = () => {}) {
	this.unwrappedPush(location, onComplete, onAbort);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js